import script from "./CompanyInformationFormAdvice.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyInformationFormAdvice.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyInformationFormAdvice.vue?vue&type=style&index=0&id=14466ebc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14466ebc"]])

export default __exports__